<template>
  <b-modal :title="helper.trans('menu.items.accountOperations')"
           dialog-class="modal-xl"
           body-class="p-0"
           :modelValue="accountToShow !== null"
           footer-class="d-flex justify-content-end"
           @update:modelValue="$event === false && (closeModal())">
    <template #default>
      <AccountOperations v-if="accountToShow" :account="accountToShow" class="modal-card"/>
    </template>
    <template #footer>
      <button type="button" @click.prevent="closeModal()" class="btn btn-outline-dark btn-sm text-capitalize-first">
        {{ helper.trans('button.ok')  }}
      </button>
    </template>
  </b-modal>
</template>

<script lang="ts">

import {defineComponent} from 'vue'
import {reactive, toRefs} from "@vue/reactivity";
import {helper} from "@/service/CommonHelper";
import APIClient from "@/service/APIClient";
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import {BModal} from "bootstrap-vue-3";
import AccountOperations from "@/views/AccountOperations.vue";
import AccountDTO from "@/models/AccountDTO";

const api = new APIClient();

export default defineComponent({
  name: "AccountOperationsModal",
  components: {
    AccountOperations,
    BModal,
  },
  setup() {

    const state = reactive({
      accountToShow: null as AccountDTO|null,
    });

    const closeModal = () => {
      state.accountToShow = null
    }

    const showModal = (account: AccountDTO|null) => {
      if (!account) {
        state.accountToShow = null
      } else {
        state.accountToShow = {...account} as AccountDTO
      }
    }

    return {
      ...toRefs(state),
      dateHelper,
      numberFormatter,
      helper,
      closeModal,
      showModal
    }
  }
})
</script>
